import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

// Actions
import { actions as audioActions } from 'modules/audio/actions'

// Hooks
import { useCurrentPos, useLoop, useAudioPlayStates, useAudio } from 'modules/audio/hooks'
import { useMaxWidth } from '@tracklib/kit'
import { useProfile } from 'modules/profile/hooks'

// Utils
import { audioBackend } from 'modules/audio/backend'
import { PREVIEW_LIMIT } from '@constants'

import styles from './progressbar.css'

const ProgressBar = ({ invisible }: { invisible: boolean }) => {
  const dispatch = useDispatch()
  const currentPos = useCurrentPos()
  const isSmall = useMaxWidth()
  const { loop } = useLoop()
  const { songItemId, contextKey } = useAudio()
  const { isActive, isPlaying } = useAudioPlayStates(songItemId, contextKey)
  const profile = useProfile()

  // Track each time loop restarts
  useEffect(() => {
    let loopTrackingInterval: NodeJS.Timer
    if (isActive && isPlaying && loop && loop.time_start && loop.time_end) {
      const { time_start, time_end } = loop
      loopTrackingInterval = setInterval(() => {
        dispatch(audioActions.trackLoop(loop))
      }, (time_end - time_start) * 1000)
    }
    return () => clearInterval(loopTrackingInterval)
  }, [dispatch, isActive, isPlaying, loop])

  const total = audioBackend?.audioElement?.duration || 0
  const useTrackPreview = profile?.id === 0 || !profile
  useEffect(() => {
    if (currentPos >= total || (useTrackPreview && currentPos >= PREVIEW_LIMIT && !loop)) {
      dispatch(audioActions.endPlay())
    }
  }, [dispatch, currentPos, total, useTrackPreview, loop])

  if (!isSmall || invisible) {
    return null
  }

  return <div className={styles.progress} style={{ transform: `scaleX(${currentPos / total})` }} />
}

export default ProgressBar
